import { Chip, CircularProgress } from '@mui/material'

import { formatInTimeZone } from 'date-fns-tz/formatInTimeZone'
import { millisecondsInDay } from 'date-fns/constants'
import { format } from 'date-fns/format'
import { isAfter } from 'date-fns/isAfter'
import { enGB } from 'date-fns/locale/en-GB'
import { millisecondsToHours } from 'date-fns/millisecondsToHours'
import { millisecondsToMinutes } from 'date-fns/millisecondsToMinutes'
import { parseISO } from 'date-fns/parseISO'

import { parseServiceDate } from './ServiceSelectionGraphql/serviceWeeks'

interface OrderTimeLeftProps {
  timezone?: string | null
  menuClosed: boolean
  openingTime?: string | null
  orderTimeRemaining?: number | null
}

export function OrderTimeLeft({
  timezone,
  menuClosed,
  openingTime,
  orderTimeRemaining,
}: OrderTimeLeftProps) {
  let textTimeLeft = ''
  let textTimeLeftSuffix = ''
  const now = new Date()
  const openingDate =
    openingTime === undefined
      ? now
      : openingTime === null
        ? new Date(NaN)
        : timezone
          ? parseServiceDate(openingTime, timezone)
          : parseISO(openingTime)
  const isNotYetOpen = isAfter(openingDate, now)

  if (isNotYetOpen) {
    const openingDay = timezone
      ? formatInTimeZone(openingDate, timezone, 'EEE do', { locale: enGB })
      : format(openingDate, 'EEE do', { locale: enGB })
    textTimeLeft = `Opens ${openingDay}`
  } else if (menuClosed) {
    textTimeLeft = 'Closed'
  } else if (orderTimeRemaining !== undefined && orderTimeRemaining !== null) {
    const hours = millisecondsToHours(orderTimeRemaining) % 24
    const minutes = millisecondsToMinutes(orderTimeRemaining) % 60
    if (orderTimeRemaining >= millisecondsInDay) {
      const days = Math.floor(orderTimeRemaining / millisecondsInDay)
      const dayText = days > 1 ? 'days' : 'day'
      const hourText = hours > 1 ? 'hrs' : 'hr'
      textTimeLeft = `${days} ${dayText}${hours > 0 ? ` ${hours}${hourText}` : ''}`
    } else {
      textTimeLeft = `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`
    }
    textTimeLeftSuffix = ' left'
  }

  return (
    <Chip
      sx={{ width: '100%' }}
      color="warning"
      size="medium"
      label={
        textTimeLeft ? (
          <>
            {textTimeLeft} {textTimeLeftSuffix}
          </>
        ) : (
          <CircularProgress size={15} />
        )
      }
    />
  )
}
